import React from "react";

import fssc22000Img from "../../assets/Images/certificates/fssc-22000.svg";
import brosImg from "../../assets/Images/certificates/bros.svg";
import fdaImg from "../../assets/Images/certificates/fda.svg";
import haccpImg from "../../assets/Images/certificates/haccp.svg";
import cgmpImg from "../../assets/Images/certificates/cgmp.svg";
import isoImg from "../../assets/Images/certificates/iso.svg";
import gmpImg from "../../assets/Images/certificates/gmp.svg";

export default function Accreditation({
  logos = [
    { id: 1, name: "FSSC 22000", imageSrc: fssc22000Img },
    { id: 2, name: "BRCGS", imageSrc: brosImg },
    { id: 3, name: "FDA", imageSrc: fdaImg },
    { id: 4, name: "HACCP", imageSrc: haccpImg },
    { id: 5, name: "CGMP", imageSrc: cgmpImg },
    { id: 6, name: "ISO", imageSrc: isoImg },
    { id: 7, name: "GMP", imageSrc: gmpImg },

    // Duplicate for smooth infinite slider
    { id: 8, name: "FSSC 22000", imageSrc: fssc22000Img },
    { id: 9, name: "BRCGS", imageSrc: brosImg },
    { id: 10, name: "FDA", imageSrc: fdaImg },
    { id: 11, name: "HACCP", imageSrc: haccpImg },
    { id: 12, name: "CGMP", imageSrc: cgmpImg },
    { id: 13, name: "ISO", imageSrc: isoImg },
    { id: 14, name: "GMP", imageSrc: gmpImg },
  ],
}) {
  return (
    <section className="relative w-full bg-white py-16 sm:py-20 overflow-hidden">

      {/* INLINE CSS */}
      <style>{`
        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        @keyframes marquee {
          0% {
            transform: translateX(0);
          }

          100% {
            transform: translateX(-50%);
          }
        }

        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 18s linear infinite;
        }

        .marquee-track:hover {
          animation-play-state: paused;
        }

        .logo-card {
          transition: all 0.4s ease;
        }

        .logo-card:hover {
          transform: translateY(-6px);
        }

        .logo-card img {
          transition: transform 0.4s ease;
        }

        .logo-card:hover img {
          transform: scale(1.08);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* HEADER */}
        <div className="text-center mb-14 lg:mb-20">

          {/* Small Label */}
          <p className="text-[#6B8A1A] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
            CERTIFIED EXCELLENCE
          </p>

          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-[#355931] leading-tight">
            Membership & <span className="gradient-text"> Accreditation </span>
     
              
          </h2>

             {/* Underline */}
            <div
              className="
                w-24
                h-[2px]
                mx-auto
                mt-6
                mb-6
                dw-fade-up
              "
              style={{
                animationDelay: "240ms",
                background:
                  "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
              }}
            />

          {/* Description */}
          <p className="max-w-2xl mx-auto text-gray-600 text-sm sm:text-base leading-relaxed px-2">
            Nutralike operates with globally recognized certifications,
            ensuring premium quality standards, regulatory compliance,
            manufacturing excellence, and trusted nutraceutical production.
          </p>

        </div>

        {/* LOGO SLIDER */}
        <div className="relative overflow-hidden">

          {/* Left Gradient */}
          <div className="absolute left-0 top-0 h-full w-16 sm:w-24 z-20 pointer-events-none bg-gradient-to-r from-white to-transparent" />

          {/* Right Gradient */}
          <div className="absolute right-0 top-0 h-full w-16 sm:w-24 z-20 pointer-events-none bg-gradient-to-l from-white to-transparent" />

          {/* Marquee */}
          <div className="marquee-track gap-6 sm:gap-8 lg:gap-10">

            {[...logos, ...logos].map((logo, index) => (

              <div
                key={`${logo.id}-${index}`}
                className="
                  logo-card
                  flex-shrink-0
                  bg-white
                  border
                  border-[#eef2ea]
                  rounded-3xl
                  shadow-sm
                  px-6
                  py-5
                  sm:px-8
                  sm:py-6
                  flex
                  items-center
                  justify-center
                  min-w-[160px]
                  sm:min-w-[200px]
                  lg:min-w-[240px]
                  h-[100px]
                  sm:h-[120px]
                "
              >

                {logo.imageSrc ? (
                  <img
                    src={logo.imageSrc}
                    alt={logo.name}
                    className="
                      max-h-[70px]
                      sm:max-h-[80px]
                      lg:max-h-[100px]
                      w-auto
                      object-contain
                    "
                  />
                ) : (
                  <span className="text-[#355931] font-semibold text-sm sm:text-base">
                    {logo.name}
                  </span>
                )}

              </div>

            ))}

          </div>

        </div>

      </div>

    </section>
  );
}